import * as React from 'react'
import { Provider, Store } from 'react-redux'
import { renderRoutes } from 'react-router-config'
import { BrowserRouter } from 'react-router-dom'

import { IRootState } from '../../common/reducers'
import routes from '../../common/routes.v0'
import PendingNavDataLoader from '../components/pendingNavDataLoader'

const App = ({ store }: { store: Store<IRootState> }) => (
  <Provider store={store}>
    <BrowserRouter>
      <PendingNavDataLoader store={store} routes={routes}>
        {renderRoutes(routes)}
      </PendingNavDataLoader>
    </BrowserRouter>
  </Provider>
)

export default App



// WEBPACK FOOTER //
// ./client/v0/app.tsx